import React from 'react';
import { SomethingWentWrongErrorBoundary } from '../../Fallbacks/SomethingWentWrongErrorBoundary';
import { a11yTabPanelProps } from './utils';

type TabPanelWithErrorHandlingProps = {
  name: string;
  children: React.ReactNode;
  ignoreErrorMessages?: string[];
};

export const TabPanelWithErrorHandling = ({
  children,
  name,
  ignoreErrorMessages,
}: TabPanelWithErrorHandlingProps) => {
  return (
    <div role="tabpanel" {...a11yTabPanelProps(name)}>
      <SomethingWentWrongErrorBoundary ignoreErrorMessages={ignoreErrorMessages}>
        {children}
      </SomethingWentWrongErrorBoundary>
    </div>
  );
};
